//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from "react-redux";

const selectore = (state) => {
  return state.sentenceStarter;
};
export const useSentenceStarter = () => {
  const selectedData = useSelector(selectore, shallowEqual);
  return selectedData;
};

export const useSentenceStarterPopUp = () => {
  const selectedData = useSelector(
    (state) => state?.sentenceStarterPopup,
    shallowEqual
  );
  return selectedData;
};
